var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyBarrel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16051_100828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0.5C5.5 0.367392 5.55268 0.240215 5.64645 0.146447C5.74021 0.0526784 5.86739 0 6 0L10 0C10.1326 0 10.2598 0.0526784 10.3536 0.146447C10.4473 0.240215 10.5 0.367392 10.5 0.5C10.5 0.632608 10.4473 0.759785 10.3536 0.853553C10.2598 0.947322 10.1326 1 10 1H6C5.86739 1 5.74021 0.947322 5.64645 0.853553C5.55268 0.759785 5.5 0.632608 5.5 0.5ZM12.5 3.5V14C12.5 14.3978 12.342 14.7794 12.0607 15.0607C11.7794 15.342 11.3978 15.5 11 15.5H5C4.60218 15.5 4.22064 15.342 3.93934 15.0607C3.65804 14.7794 3.5 14.3978 3.5 14V3.5C3.5 3.10218 3.65804 2.72064 3.93934 2.43934C4.22064 2.15804 4.60218 2 5 2H11C11.3978 2 11.7794 2.15804 12.0607 2.43934C12.342 2.72064 12.5 3.10218 12.5 3.5ZM11.5 3.5C11.5 3.36739 11.4473 3.24021 11.3536 3.14645C11.2598 3.05268 11.1326 3 11 3H5C4.86739 3 4.74021 3.05268 4.64645 3.14645C4.55268 3.24021 4.5 3.36739 4.5 3.5V14C4.5 14.1326 4.55268 14.2598 4.64645 14.3536C4.74021 14.4473 4.86739 14.5 5 14.5H11C11.1326 14.5 11.2598 14.4473 11.3536 14.3536C11.4473 14.2598 11.5 14.1326 11.5 14V3.5Z",
    fill: "#9E3A3C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16051_100828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBarrel);
export default __webpack_public_path__ + "static/media/EmptyBarrel.a549a79c41059f460ec60b42bbffd1c4.svg";
export { ForwardRef as ReactComponent };